const apiKeys = {
 trefleAPI: "TXR2Ym5kN1ArbE5aVFJkTXdkL0NkZz09",
};

export default apiKeys;
